<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 订单管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                  type="primary"
                  icon="el-icon-delete"
                  class="handle-del mr10"
                  @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-select class="handle-select mr10 wd200" clearable placeholder="订单类型" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="'【'+item.cityName+'】-'+item.Sname"
                               :value="item.Id"
                               v-for="item in sceOpt.area"></el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="订单编号/关键字" v-model="search.keyword"></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getOrderData" icon="el-icon-refresh" type="warning">刷新</el-button>
            </div>
            <el-table
                    :data="tableData"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="订单ID" prop="Id" sortable></el-table-column>
                <el-table-column align="center" label="订单编号" prop="Oid" sortable width="265"></el-table-column>
                <el-table-column align="center" label="景区名称" prop="Oscenic" sortable></el-table-column>
                <el-table-column align="center" label="游玩日期" prop="Otraveldate" sortable></el-table-column>
                <el-table-column align="center" label="预定人" prop="Auser"></el-table-column>
                <el-table-column align="center" label="出游人数" prop="Osum"></el-table-column>
                <el-table-column align="center" label="下单时间" prop="Osubdate"></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '已取消', value: '0' }, { text: '待确认', value: '1' }, { text: '待支付', value: '2' }, { text: '待出行', value: '3' }, { text: '已完成', value: '4' }]"
                                 align="center"
                                 label="订单状态"
                                 prop="Ostate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Ostate===0?'danger':(scope.row.Ostate===1?'danger':(scope.row.Ostate===2?'warning':(scope.row.Ostate===3?'info':'success')))"
                        >
                            {{scope.row.Ostate===0?'已取消':(scope.row.Ostate===1?'待确认':(scope.row.Ostate===2?'待支付':(scope.row.Ostate===3?'待出行':'已完成')))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="getTickets(scope.$index, scope.row)"
                                icon="el-icon-picture-outline"
                                type="text"
                        >拥有门票
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 弹出框@编辑订单详情信息 -->
        <el-dialog :visible.sync="editVisible" title="订单详情信息" width="50%">
            <el-form :model="form" label-width="90px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="订单编号：">{{form.Oid}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="景点名称：">{{form.Oscenic}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="出游人数：">{{form.Osum}}</el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="出游日期：">{{form.Otraveldate}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户名称：">{{form.Auser}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客户电话：">{{form.Auserphone}}</el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="下单时间：">{{form.Osubdate}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客人姓名：">{{form.Ocontact}}</el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="客人电话："><el-input clearable v-model="form.Ocontactphone"></el-input></el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="门票类型：">
                            <el-select placeholder="请选择" v-model="form.Ostate">
                                <el-option :key="item.value"
                                           :label="item.tname+'-V'+item.tprice_peer+'/'+item.tprice_team+'; P'+item.tprice_peerN+'/'+item.tprice_teamN"
                                           :value="item.value"
                                           v-for="item in ticketData"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="订单金额："><el-input clearable v-model="form.Ocount"></el-input></el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="订单状态：">
                            <el-select placeholder="请选择" v-model="form.Ostate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in orderState"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col>
                        <el-form-item label="客人备注：">{{form.Omemo}}</el-form-item>
                    </el-col>

                </el-row>

                <el-form-item label="操作备注：">
                    <el-input
                            maxlength="5000"
                            placeholder="请输入操作内容"
                            rows="10"
                            show-word-limit
                            type="textarea"
                            v-model="form.Sdescription"
                    ></el-input>
                </el-form-item>

            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                orderState: [{
                    value: 0,
                    label: '已取消'
                }, {
                    value: 1,
                    label: '待确认'
                }, {
                    value: 2,
                    label: '待支付'
                }, {
                    value: 3,
                    label: '待使用'
                }, {
                    value: 4,
                    label: '已完成'
                }],
                ticketData: [],

                tags: [],
                orderVisible: false,
                orderData: [],
                sceOpt: {
                },
                query: {
                    pageIndex: 1,
                    pageSize: 10
                },
                search: {
                    keyword: '',
                    menu: '',
                    sdid: sessionStorage.getItem('ml_cityId')
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                editVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1,
                fileList: [],
                image_type: 1,
                cityName:'guilin',
                imgUrl:''
            };
        },
        created() {
            // this.reload();
            this.getOrderData();
        },
        methods: {
            //初始化 景点列表数据
            async getOrderData() {
                const { data: res } = await this.$http.post('admin/trade/initOrderData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.sceOpt.area = res.area;
                this.tags = res.tags;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 10;
                this.search.keyword = '';
                this.search.menu = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【订单数据】加载成功!');
            },
            // 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/scenics/searchScenic', {
                    search: this.search
                });

                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.sceOpt.area = res.area;
                this.tags = res.tags;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },
            // 编辑景点信息操作
            async handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
                this.getTickets(this.form.Opid)
            },

            // 查看景点拥有门票
            async getTickets(id) {
                const { data: res } = await this.$http.post('/admin/scenics/getTickets', {
                    pid: id,
                    type: '1'
                });
                this.ticketData = res;
            },


            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/trade/updateOrder', {
                    form: this.form,
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getOrderData();
            },
            //标签筛选
            filterTag(value, row) {
                return row.Sstate == value;
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd100 {
        width: 90px;
    }

    .wd400 {
        width: 400px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
